import { QuotaMergeMode } from 'dy-frontend-http-repository/lib/data/enums';

const quotaMergeModeInformation: { [quotaMergeMode in QuotaMergeMode]: string } = {
    [QuotaMergeMode.SET]: 'Set',
    [QuotaMergeMode.SUM]: 'Add',
};

export default quotaMergeModeInformation;
